import Button from "@/components/button";
import Categorized from "@/components/categorized";
import ExtLink from "@/components/ext-link";
import RestoreBtn from "@/components/restore-btn";
import SetStatus from "@/containers/set-status";
import {dashedCase} from "@/utils/functions";
import {uniq} from "lodash";
import {mapGetters} from "vuex";

export default {
    name: "neo-search-engine-result",
    components: {
        "neo-button": Button,
        "neo-restore-btn": RestoreBtn,
        "neo-set-status": SetStatus,
        "neo-categorized": Categorized,
        "neo-ext-link": ExtLink,
    },
    props: ["content", "setStatus", "restore", "tab"],
    data() {
        return {
            controls: {
                status: this.content.status,
            },
        };
    },
    computed: {
        ...mapGetters(["getReadOnlyMode"]),
        search_engines() {
            return uniq(this.content.search_source.map((elem) => elem.source));
        },
    },
    mounted() {},
    methods: {
        markDone() {
            alert(1234);
        },
        setStatusAsDone() {
            this.controls.status = "CONFIRMED";
            this.onStatChanges("CONFIRMED");
        },
        dashed(string) {
            return dashedCase(string);
        },
        onStatChanges(status) {
            this.$emit("dataChanges", {...this.content, status});
        },
    },
};
